module.exports = __webpack_public_path__ + "static/media/DSC07453.20cd67e2.jpg";